export const ADD_PROJECTS = "ADD_PROJECT";
export const PROJECTS_LOADING = "PROJECT_LOADING";
export const PROJECTS_FAILED = "PROJECT_FAILED";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const MESSAGE_ERROR = "MESSAGE_ERROR";
export const MESSAGE_LOADING = "MESSAGE_LOADING";
export const ADD_LOGIN = "ADD_LOGIN";
export const LOGIN_LOADING = "LOGIN_LOADING";

